import type { TimelineRow } from '@tabel/shared/agent-events/timeline';
import { CircleAlert, Info, Square, TriangleAlert } from 'lucide-react';
import { memo } from 'react';
import { Callout } from '../../ui';

type Row = Extract<TimelineRow, { kind: 'system' }>;

const VIEW = {
  info: { tone: 'accent', icon: Info },
  warn: { tone: 'warn', icon: TriangleAlert },
  bad: { tone: 'bad', icon: CircleAlert },
  mute: { tone: 'neutral', icon: Square },
} as const;

/**
 * Системная строка ленты с сервера: «Агент остановлен. Это не ошибка.», «Модель сменилась: A → B», «Начат новый
 * разговор с агентом…», ошибка модели. Вид — Callout дизайн-системы по тону.
 */
export const SystemRow = memo(function SystemRow({ row }: { row: Row }) {
  const v = VIEW[row.tone];
  return (
    <Callout tone={v.tone} icon={v.icon}>
      <p className="break-words">
        <span className="font-semibold">{row.title}</span>
        {row.text && <> {row.text}</>}
      </p>
    </Callout>
  );
});
